// extracted by mini-css-extract-plugin
export default {"selection":"PatentFieldSelection-module_selection_a4adf33c","title":"PatentFieldSelection-module_title_db1ca20c"};